const SeccionSecundaria = () =>{

    return(
        <div className='py-4' id='SeccionSecundaria'>
            <h1 className="text-center fw-bold text-light animate__animated animate__pulse">La mejor calidad solo para vos</h1>
            <div className="calidadiso">
                    <img src="../img/Calidad.png" height="210px" alt="img"/>
            </div>   
        </div>
        
    );
}
    
export default SeccionSecundaria;